import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import ChangePasswordDialog from './shared/ChangePasswordDialog';

const ForcePasswordChangeWrapper = ({ children }) => {
    const { user, login } = useAuth();
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (user?.needs_password_change) {
            setOpen(true);
        } else {
            setOpen(false);
        }
    }, [user]);

    const handleComplete = () => {
        // Refresh user state after password change
        // We could either reload or just update the user object locally
        // Since we cleared needs_password_change in the backend, 
        // we should fetch 'me' again or just update local user.
        const updatedUser = { ...user, needs_password_change: false };
        localStorage.setItem('user', JSON.stringify(updatedUser));
        // Since AuthContext doesn't have an 'updateUser' we might need to add one or just window.location.reload()
        window.location.reload();
    };

    return (
        <>
            {children}
            <ChangePasswordDialog
                open={open}
                onOpenChange={setOpen}
                onComplete={handleComplete}
                force={true}
            />
        </>
    );
};

export default ForcePasswordChangeWrapper;
